import styled from '@emotion/styled';

import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';

export const VariantsWrapper = styled.div`
  padding-top: 10px;
  ${({ theme }) => theme.variants.wrapper};
`;

export const VariantsInner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const OptionBlock = styled.div`
  margin-top: 20px;

  &:first-of-type {
    margin-top: 0;
  }

  ${({ theme }) => theme.variants.option};
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  gap: 5px;
`;

export const LabelText = styled.p`
  flex-shrink: 0;
`;

export const SelectedOption = styled.span`
  padding-right: 26px;
  color: ${({ theme }) => theme.colors.dark};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: -5px;
  right: 0;
  padding: 5px;
`;

export const ArrowImage = styled(ArrowDownIcon)`
  transform: rotate(-180deg);
`;
